import React, { useState } from "react"
import ReactHtmlParser from "react-html-parser"
import Svg from "../_svgs/svg"
import HotspotSvg from "./hotspot-svg-component"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function HotspotImageBlockComponent({ title, infographic, focalPoints, bottomPadding, topPadding }) {
  const [selectedFocal, setSelectedFocal] = useState(null)
  const [activePoint, setActivePoint] = useState(null)
  const [zoomLevel, setZoomLevel] = useState(1) // 1 means no zoom
  const [translateX, setTranslateX] = useState(0) // 0 means no shift
  const [translateY, setTranslateY] = useState(0) // 0 means no shift
  const windowWidth = useWindowWidth()
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)

  const handleClose = () => {
    setSelectedFocal(null)
    setActivePoint(null)
    setZoomLevel(1) // Reset zoom when closed
    setTranslateX(0) // Reset shift when closed
    setTranslateY(0) // Reset shift when closed
  }

  const imageAndPointsStyle = {
    transform: `scale(${zoomLevel}) translate(${translateX}%, ${translateY}%)`,
  }

  return (
    <div className={`hotspot-image-block-container ${tp ? tp : ""} ${bp ? bp : ""}`}>
      <div className="w--wider">
        <div data-epi-property="Title" className="main-text">
          {ReactHtmlParser(title)}
        </div>
        <div className="hotspot-image-border">
          <div className="hotspot-image-container">
            <div style={imageAndPointsStyle}>
              <div className="hotspot-image">{infographic ? <img src={infographic} alt="" className="infographic" /> : <HotspotSvg />}</div>
              <div className="icons">
                {focalPoints.map((point, index) => (
                  <FocalPoint
                    key={index}
                    point={point}
                    selectedFocal={selectedFocal}
                    setSelectedFocal={setSelectedFocal} // Pass setSelectedFocal as a prop
                    setActivePoint={setActivePoint}
                    index={index}
                    active={index === selectedFocal} // Use === for strict comparison
                    setTranslateX={setTranslateX}
                    setTranslateY={setTranslateY}
                    setZoomLevel={setZoomLevel}
                    windowWidth={windowWidth}
                  />
                ))}
              </div>
            </div>
            <div className={`focal-point-content ${activePoint ? "show" : ""}`}>
              <button className="close-icon" onClick={handleClose}>
                <Svg iconName={"close-new"} />
              </button>
              <div data-epi-property="Title" className="rich-text">
                <h3>{ReactHtmlParser(activePoint?.title)}</h3>
                {ReactHtmlParser(activePoint?.information)}
              </div>
              <a target={activePoint?.target[0]?.value || "_blank"} href={activePoint?.readMore}>
                {activePoint?.readMoreText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function FocalPoint({
  active,
  setSelectedFocal,
  selectedFocal,
  index,
  setActivePoint,
  point,
  setTranslateX,
  setTranslateY,
  setZoomLevel,
  windowWidth,
}) {
  const iconStyle = {
    position: "absolute",
    top: `${point.yCoordinate}%`,
    left: `${point.xCoordinate}%`,
    cursor: "pointer",
  }

  // Utility function to clamp a value between a min and max
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max)
  }

  const handleClick = () => {
    if (index === selectedFocal) {
      setSelectedFocal(null) // if the current active focal point is clicked hide it again
      setActivePoint(null)
      setZoomLevel(1) // Reset zoom when closed
      setTranslateX(0) // Reset shift when closed
      setTranslateY(0) // Reset shift when closed
    } else {
      setSelectedFocal(index)
      setActivePoint(point)

      let zoom = 1.5
      setZoomLevel(zoom)

      if (windowWidth >= 768) {
        // Check if the point is inside the specified range
        if (point.xCoordinate >= 16 && point.xCoordinate <= 46 && point.yCoordinate >= 16 && point.yCoordinate <= 78) {
          setTranslateX(0)
          setTranslateY(0)
        } else {
          // Calculate necessary translations if point is outside the range

          // Horizontal translation
          let requiredShiftX = 0
          if (point.xCoordinate < 16) {
            // for points too far left
            requiredShiftX = 16 - point.xCoordinate
          } else if (point.xCoordinate > 46) {
            // for points too far right
            requiredShiftX = 46 - point.xCoordinate
          }

          const clampedShiftX = clamp(requiredShiftX, -50, 16)
          setTranslateX(clampedShiftX)

          // Vertical translation
          let requiredShiftY = 0
          if (point.yCoordinate < 16) {
            requiredShiftY = 16 - point.yCoordinate
          } else if (point.yCoordinate > 78) {
            requiredShiftY = 78 - point.yCoordinate
          }

          const clampedShiftY = clamp(requiredShiftY, -16, 16)
          setTranslateY(clampedShiftY)
        }
      }
    }
  }

  return (
    <div className="focal-point-block-container">
      <button
        style={iconStyle}
        onClick={handleClick} // Handle click to set the selected focal point
      >
        <Svg fillColor={active ? "#6a8ed5" : "#FFF"} iconName={active ? "focalpoint_active" : "focalpoint_inactive"}></Svg>
      </button>
    </div>
  )
}
